import { useMediaQuery } from '@/hooks/useMediaQuery';
import { AdBreakpoint } from './types';

/** Returns the current ad breakpoint: desktop (≥1024px), tablet (768-1023px), mobile (<768px) */
export function useAdBreakpoint(): AdBreakpoint {
  const isMobile = useMediaQuery('(max-width: 767px)');
  const isTablet = useMediaQuery('(min-width: 768px) and (max-width: 1023px)');
  if (isMobile) return 'mobile';
  if (isTablet) return 'tablet';
  return 'desktop';
}
